import { useState } from 'react';

import { ChevronRightIcon, ChevronLeftIcon } from '@grupoboticario/flora-react-icons';
import { CycleProps } from 'core/domains/user';
import { Cycle } from 'ui/components';

import Styles from './Cycle.styles';
import VdfCycleEmpty from './VdfCycleEmpty';

interface TCycleControls {
  vdfCycles: CycleProps[];
}

const CycleControls = ({ vdfCycles }: TCycleControls) => {
  if (!vdfCycles.length) {
    return <VdfCycleEmpty />;
  }

  const [currentCycleIndex, setCurrentCycleIndex] = useState(0);
  const activeArrowBack = currentCycleIndex > 0;
  const activeArrowForward = currentCycleIndex !== vdfCycles.length - 1;

  return (
    <>
      <Styles.ArrowBack
        data-testid="previous-cycle"
        data-active={activeArrowBack}
        onClick={() => activeArrowBack && setCurrentCycleIndex(currentCycleIndex - 1)}
      >
        <ChevronLeftIcon />
      </Styles.ArrowBack>
      <Cycle
        finalDate={vdfCycles[currentCycleIndex].finalDate}
        initialDate={vdfCycles[currentCycleIndex].initialDate}
        currentCycle={vdfCycles[currentCycleIndex].currentCycle}
        daysLeft={vdfCycles[currentCycleIndex].daysLeft}
        daysTotal={vdfCycles[currentCycleIndex].daysTotal}
        name={vdfCycles[currentCycleIndex].name}
        isMultiBrand
      />
      <Styles.ArrowForward
        data-testid="next-cycle"
        data-active={activeArrowForward}
        onClick={() => activeArrowForward && setCurrentCycleIndex(currentCycleIndex + 1)}
      >
        <ChevronRightIcon />
      </Styles.ArrowForward>
    </>
  );
};

export default CycleControls;
